<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <v-select
      v-model="inputValue"
      :filter="customFilter"
      :disabled="disabled"
      :id="inputId"
      :options="marks"
      :reduce="x => x.name"
      :taggable="taggable"
      :push-tags="true"
      :create-option="createOption"
      type="text"
      label="name"
      autocomplete="off"
      transition=""
    >
      <span slot="no-options">Марка не найдена. <br>Можете ввести модель вручную.</span>
      <template #open-indicator="{ attributes }">
        <svg width="14" height="8" xmlns="http://www.w3.org/2000/svg" v-bind="attributes">
          <path stroke="null" id="svg_1" d="m10.838366,0.093268l-4.59,4.58l-4.59,-4.58l-1.41,1.41l6,6l6,-6l-1.41,-1.41z"/>
        </svg>
      </template>
    </v-select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import VSelect from 'vue-select'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import transportInputMixin from '../../../../mixins/application-form/transportInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TransportMarkInput',

  components: {
    Hint,
    VSelect
  },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    transportInputMixin
  ],

  props: {
    taggable: {
      type: Boolean,
      default: false
    },

    inputLabel: {
      default: 'Марка ТС'
    },

    inputName: {
      default: 'mark'
    },

    inputHint: {
      default: undefined
    },

    marks: {
      type: Array,
      default: () => [],
      required: true
    },

    typeaheadItemKey: {
      default: 'name'
    }
  },

  computed: {
    inputId() {
      return `form-visitor-transport-${this.inputName}-${this.visitorIndex}-${this.transportIndex}`
    }
  },

  methods: {
    customFilter(marks, search) {
      return marks.filter(mark =>
        mark.name.toLowerCase().startsWith(search.toLowerCase()) ||
        mark.name_rus.toLowerCase().startsWith(search.toLowerCase()))
    },

    createOption(newOption) {
      newOption = { name: newOption, name_rus: newOption }
      this.$emit('option:created', newOption)

      return newOption
    }
  }
}
</script>
